import type { FleetView } from '../../../apps/apis/commandCenter/types';

interface FleetStripProps {
  fleet: FleetView | undefined;
  isError: boolean;
}

/** Live node presence line; the fleet is empty until nodes start heart-beating. */
const FleetStrip = ({ fleet, isError }: FleetStripProps) => {
  if (isError) {
    return (
      <div className="cc-strip cc-strip-warn">fleet nodes unavailable — the agent catalog below is unaffected</div>
    );
  }
  if (!fleet || fleet.total === 0) {
    return <div className="cc-strip">No fleet nodes connected yet — presence appears here once a node registers.</div>;
  }
  return (
    <div className="cc-strip">
      <b>{fleet.online}</b> online · <b>{fleet.offline}</b> offline ·{' '}
      {fleet.nodes.slice(0, 6).map((node) => (
        <span key={node.nodeId} className={`tg ${node.online ? 'node-on' : 'node-off'}`}>
          {node.displayName ?? node.nodeId}
        </span>
      ))}
      {fleet.nodes.length > 6 ? <span className="cc-more">+{fleet.nodes.length - 6} more</span> : null}
    </div>
  );
};

export default FleetStrip;
